import { render } from "./InputSimple.vue?vue&type=template&id=ec6f6892&scoped=true"
import script from "./InputSimple.vue?vue&type=script&lang=js"
export * from "./InputSimple.vue?vue&type=script&lang=js"

import "./InputSimple.vue?vue&type=style&index=0&id=ec6f6892&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6f6892"]])

export default __exports__